module.exports = __webpack_public_path__ + "static/img/mt5_platform.230be1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/mt5_platform.png
// module id = SBo4
// module chunks = 4